import React, { useCallback } from 'react'
import OnboardingValidationCodeView from './on-boarding-validation-code.view'
import OnBoardingStepperView from './on-boarding-stepper.view'

/**
 * @author Edgar Escobedo
 * @description Renders the appropriate onboarding component based on the nameComponent prop
 * @createdDate 08-10-2025 
 * @param {Object} props - The props for the component
 * @param {string} props.nameComponent - The name of the component to render
 * @param {string} props.validationCode - The validation code for the onboarding process
 * @param {Object} props.dataUser - The user data for the onboarding process
 * @param {string} props.dataUser.name - The name of the user
 * @param {string} props.dataUser.lastName - The last name of the user
 * @param {string} props.dataUser.secondLastName - The second last name of the user
 * @param {string} props.dataUser.cellphoneNumber - The cellphone number of the user
 * @param {string} props.password - The password for the user
 * @param {string} props.confirmPassword - The confirmation password for the user
 * @param {string} props.changePasswordShowPasswordIcon - The icon for showing/hiding the password
 * @param {string} props.changePasswordShowPasswordConfirmIcon - The icon for showing/hiding the confirmation password
 * @param {boolean} props.showErrorName - Flag to show error for name field
 * @param {boolean} props.showErrorLastName - Flag to show error for last name field
 * @param {boolean} props.showErrorSecondLastName - Flag to show error for second last name field
 * @param {boolean} props.showErrorCellphoneNumber - Flag to show error for cellphone number field
 * @param {boolean} props.showErrorPassword - Flag to show error for password field
 * @param {boolean} props.showErrorConfirmPassword - Flag to show error for confirmation password field
 * @param {number} props.selectedStep - The current step in the onboarding process
 * @param {Array} props.steps - The steps in the onboarding process
 * @returns {JSX.Element} - The NewUserOnboardingConfigView component
 */
const NewUserOnboardingConfigView = (props) => {
  let {
    nameComponent,
    validationCode,
    dataUser,
    password,
    confirmPassword,
    changePasswordShowPasswordIcon,
    changePasswordShowPasswordConfirmIcon,
    showErrorName,
    showErrorLastName,
    showErrorSecondLastName,
    showErrorCellphoneNumber,
    showErrorPassword,
    showErrorConfirmPassword,
    selectedStep,
    steps
  } = props

  const renderNewUserOnboarding = useCallback(() => {
    switch (nameComponent) {
      case 'validationCode':
        return (
          <OnboardingValidationCodeView {...props} />
        )
      case 'onBoarding':
        return (
          <OnBoardingStepperView {...props} />
        )

      default:
        return
    }
  }, [
    nameComponent,
    validationCode,
    dataUser,
    password,
    confirmPassword,
    changePasswordShowPasswordIcon,
    changePasswordShowPasswordConfirmIcon,
    showErrorName,
    showErrorLastName,
    showErrorSecondLastName,
    showErrorCellphoneNumber,
    showErrorPassword,
    showErrorConfirmPassword,
    selectedStep,
    steps
  ])

  return (
    <>
      {renderNewUserOnboarding()}
    </>
  )
}

export { NewUserOnboardingConfigView as default }